import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PopoverController } from '@ionic/angular';

@Component({
  selector: 'app-selector-fecha',
  templateUrl: './selector-fecha.component.html',
  styleUrls: ['./selector-fecha.component.scss'],
})
export class SelectorFechaComponent implements OnInit {
  @Input() setFecha = '';
  @Output() getFecha=new EventEmitter();
  datePipe = new DatePipe("en-US")

  constructor(private popover: PopoverController) { }

  ngOnInit() {}

  FechaSelect(){
    if(!this.setFecha){
      this.setFecha = this.datePipe.transform(new Date(), "yyyy-MM-dd")
    }
    this.getFecha.emit(this.setFecha)
    this.popover.dismiss(this.setFecha)
  }
}
